<template>
  <div>
    <h1 class="sm:mb-8 text-center text-2xl lg:text-3xl font-semibold">
      Add caterer info
    </h1>
    <section class="flex flex-wrap justify-center">
      <div class="min-w-full sm:min-w-30 max-w-2xl flex-1 m-2">
        <div class="bg-white rounded-lg shadow-card p-8 self-start sm:p-12">
          <div class="sm:flex sm:mb-4">
            <fieldset class="flex-1 sm:mr-2 mb-4 sm:mb-0">
              <label for="firstName">First name<small>*</small></label>
              <input type="text" class="input mt-2" id="firstName" v-model="firstName" />
            </fieldset>
            <fieldset class="flex-1 sm:ml-2 mb-4 sm:mb-0">
              <label for="lastName">Last name<small>*</small></label>
              <input type="text" class="input mt-2" id="lastName" v-model="lastName " />
            </fieldset>
          </div>
          <div class="sm:flex mb-4">
            <fieldset class="flex-1 sm:mr-2 mb-4 sm:mb-0">
              <label for="email">Email<small>*</small></label>
              <input type="email" class="input mt-2" id="email" v-model="email" />
            </fieldset>
            
            <fieldset class="flex-1 sm:ml-2 mb-4 sm:mb-0">
              <label for="companyName">Company Name</label>
              <input type="text" class="input mt-2" id="companyName" v-model="companyName">
            </fieldset>
          </div>
          
          <div class="flex justify-center flex-col-reverse sm:flex-row mt-10">
            <button
              class="btn btn-secondary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-auto sm:flex-none"
              @click="$emit('next')"
              v-if="!canAddAnother"
            >
              Skip
            </button>
            <button
              class="btn btn-secondary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-48 sm:flex-none"
              :disabled="!canSubmit"
              @click="submitCaterer"
              v-if="canAddAnother"
            >
              <Spinner v-if="loading" class="mx-auto" orange />
              <span v-else>Add Another</span>
            </button>
            <button
              class="btn btn-primary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-auto sm:flex-none"
              @click="$emit('next')"
              v-if="canAddAnother"
            >
              Next Step
            </button>
            <button
              class="btn btn-primary font-semibold rounded px-10 w-full sm:w-48 sm:flex-none"
              :disabled="!canSubmit"
              @click="submitCaterer"
              v-if="!canAddAnother"
            >
              <span v-if="!loading">Add Caterer</span>
              <Spinner class="mx-auto" v-if="loading" />
            </button>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg shadow-card p-8 self-start max-w-sm sm:p-12 m-2">
        <h1 class="mb-3 font-semibold text-lg">
          Helper Info Box
        </h1>
        <p>
          Use this form to add caterers to your order. They will be invited to the project and have limited abilities to
          print order and update order statuses related to fulfillment. You can add caterers here or through the My
          Orders menu after completing setup.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  import { email, minLength, required } from "vuelidate/lib/validators"
  import Spinner from "@/components/common/Spinner"
  import { USER_ROLES } from "@/utils/user-roles"

  const TEXT_FIELD_MIN_LENGTH = 2;

  export default {
    components: {
      Spinner
    },
    data() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        loading: false,
        canAddAnother: false
      }
    },
    validations: {
      firstName: {
        required,
        minLength: minLength(TEXT_FIELD_MIN_LENGTH),
      },
      lastName: {
        required,
        minLength: minLength(TEXT_FIELD_MIN_LENGTH)
      },
      email: {
        required,
        email
      },
      companyName: {
        minLength: minLength(TEXT_FIELD_MIN_LENGTH)
      }
    },
    computed: {
      canSubmit() {
        const { firstName, lastName, email, companyName } = this.$v
        return !firstName.$invalid
          && !lastName.$invalid
          && !email.$invalid
          && !companyName.$invalid
      }
    },
    methods: {
      async submitCaterer() {
        this.loading = true

        await this.$store.commit('SET_ORDER_COLLABORATOR_INVITATION', {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          company: this.companyName,
          role: USER_ROLES.ROLE_CATERER
        });
        
        this.loading = false
        this.canAddAnother = true
        this.clearForm()

        // Update hasCollaborator field in segmentation order in the store.
        const order = this.$store.state.segmentationOrder
        order.hasCollaborators = true
        order.process = 3;
        this.$store.commit('setSegmentationOrder', order)

        this.$emit('next')
        
      },
      clearForm() {
        this.firstName = ''
        this.lastName = ''
        this.email = ''
        this.companyName = ''
      }
    }
  }
</script>